import { OperationListColumns } from 'src/types/ViewModel/Stowage/OperationListColumns';

// Default column selections
export const getDefaultColumnSelections = (): OperationListColumns => {
    return {
        // Essential columns - always visible
        showTradeName: true,
        showProductName: true,
        showNominatedWeight: true,
        showNominatedVolume: true,
        showStowedWeight: true,
        showStowedVolume: true,
        showNotStowedWeight: true,
        showNotStowedVolume: true,
        showPorts: true,

        // Optional columns - off by default
        showCharterer: false,
        showContractWeight: false,
        showTotalCargoNominatedWeight: false,
        showBillOfLadingFigure: false,
        showShipFigure: false,
        showSwingWeights: false,
        showSwingVolumes: false,
        showOption: false,
        showLitreWeight: false,
        showHeating: false,
        showMaxAdjacentTemp: false,
        showFlashPoint: false,
        showMeltingPoint: false,
        showBoilingPoint: false,
        showTankNames: false,
        showUscgGroupNumber: false,
        showPollution: false,
        showShipType: false,
        showSource: false,
        showContractStatus: false,
    };
};

/**
 * Returns the default column selection merged with any saved user preferences,
 * ensuring all expected properties exist.
 */
export const getSavedColumnSelections = (): OperationListColumns => {
    try {
        const savedSelections = localStorage.getItem('operationListColumns');
        if (!savedSelections) return getDefaultColumnSelections();

        const parsedSelections = JSON.parse(savedSelections);

        // Merge with defaults to ensure all properties exist
        return { ...getDefaultColumnSelections(), ...parsedSelections };
    } catch (e) {
        console.error('Failed to parse saved column selections:', e);
        localStorage.removeItem('operationListColumns');
        return getDefaultColumnSelections();
    }
};
